import type { BaseKeyFunction } from "../../../../lib/types/baseKeyFunction";

export type KeyCampaignDetailsProps = { id: number };

export const keyCampaignDetails: BaseKeyFunction<KeyCampaignDetailsProps> = ({
  id,
}) => ["campaign-details", id?.toString()];
